export default __webpack_public_path__ + "static/media/aave.b747f0c6.png";